import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import { useTranslation } from "../../../shared/language";

const DialogConfirmInvoiceDiscount = ({
  visible,
  setVisible,
  handleSubmit,
}) => {
  const {t} = useTranslation();
  return (
    <Dialog
      header={t("common.commercialDiscountInvoice")}
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: "600px" }}
      footer={() => (
        <div className="flex justify-content-end">
          <Button
            label={t("common.cancel")}
            onClick={() => setVisible(false)}
            className="p-button-text p-button-sm"
          />
          <Button
            label={t("common.createInvoiceSkipList")}
            onClick={() => handleSubmit(false)}
            className="p-button-outlined p-button-sm"
          />
          <Button
            label={t("common.createInvoiceWithList")}
            onClick={() => handleSubmit(true)}
            className="p-button-sm"
          />
        </div>
      )}
    >
      <div>
        <p>
          {t('common.commercialDiscountLegalNotice')}
        </p>
        <div
          style={{ background: "#E7F3FF" }}
          className="px-4 py-2 border-round-lg mb-2"
        >
          <p className="font-bold text-xl">
            {t('common.commercialDiscountStepsTitle')}
          </p>
          <p>
            {t('common.commercialDiscountStepOne')}
          </p>
          <p>
            {t('common.commercialDiscountStepTwo')}
          </p>
          <p>
            {t('common.commercialDiscountLineNote')}
          </p>
        </div>
        <p>{t('common.askCreateInvoiceList')}</p>
      </div>
    </Dialog>
  );
};

export default DialogConfirmInvoiceDiscount;
